
import { useParams } from 'react-router-dom';
import ProductDetailHero from './components/ProductDetailHero';
import ProductFeatures from './components/ProductFeatures';
import ProductSpecifications from './components/ProductSpecifications';
import ComplianceSection from './components/ComplianceSection';
import RelatedProducts from './components/RelatedProducts';
import ProductCTA from './components/ProductCTA';

export default function CO2ExtinguishersPage() {
  const { id } = useParams();

  const product = {
    id: 4,
    title: 'CO₂ Fire Extinguishers',
    category: 'Fire Extinguishers',
    brand: 'FlameGuardQA',
    model: 'FG-CO2-01',
    certification: 'QCDD Approved',
    status: 'Available',
    image: 'https://readdy.ai/api/search-image?query=Professional%20red%20CO2%20fire%20extinguisher%20with%20black%20horn%20and%20pressure%20gauge%2C%20QCDD%20approved%20clean%20agent%20fire%20suppression%20equipment%20for%20electrical%20fires%20with%20technical%20specifications%20label%20and%20safety%20instructions&width=600&height=600&seq=co2-extinguisher-detail&orientation=squarish',
    description: 'Clean agent CO₂ extinguishers ideal for electrical and electronic equipment protection, leaving no residue after discharge. Perfect for server rooms, electrical panels, and sensitive equipment areas.'
  };

  const features = [
    'Non-conductive extinguishing agent for electrical safety',
    'Safe for use on electrical fires without damage',
    'Lightweight aluminum cylinder construction',
    'Easy to operate with simple squeeze mechanism',
    'Low maintenance requirements',
    'No residue left after discharge',
    'Suitable for Class B and C fires',
    'Environmentally friendly clean agent'
  ];

  const specifications = [
    { label: 'Model', value: 'FG-CO2-01' },
    { label: 'Type', value: 'Carbon Dioxide Fire Extinguisher' },
    { label: 'Capacity', value: '2kg / 5kg / 9kg' },
    { label: 'Working Pressure', value: '55 bar' },
    { label: 'Discharge Time', value: '12–18 seconds' },
    { label: 'Effective Range', value: '1–3 meters' },
    { label: 'Fire Classes', value: 'Class B & C' },
    { label: 'Cylinder Material', value: 'Aluminum Alloy' },
    { label: 'Operating Temperature', value: '-20°C to +60°C' },
    { label: 'Weight (5kg)', value: '15.5kg total' },
    { label: 'Certification', value: 'QCDD, ISO' },
    { label: 'Warranty', value: '2 Years' }
  ];

  const relatedProducts = [
    {
      id: 5,
      title: 'Dry Chemical Extinguishers',
      image: 'https://readdy.ai/api/search-image?query=Red%20ABC%20dry%20chemical%20fire%20extinguisher%20with%20pressure%20gauge%20and%20safety%20pin%2C%20professional%20multi-purpose%20fire%20suppression%20equipment%20with%20QCDD%20certification%20marking%20and%20technical%20specifications&width=300&height=200&seq=dry-chemical-related&orientation=landscape',
      category: 'Extinguishers',
      compliance: 'ABC Class Rated'
    },
    {
      id: 6,
      title: 'Foam Fire Extinguishers',
      image: 'https://readdy.ai/api/search-image?query=Professional%20foam%20fire%20extinguisher%20with%20cream%20colored%20body%20and%20red%20components%2C%20AFFF%20fire%20suppression%20equipment%20for%20liquid%20fires%20with%20QCDD%20approval%20and%20technical%20specifications%20label&width=300&height=200&seq=foam-extinguisher-related&orientation=landscape',
      category: 'Extinguishers',
      compliance: 'AFFF Formula'
    },
    {
      id: 17,
      title: 'Fire Extinguisher Cabinets',
      image: 'https://readdy.ai/api/search-image?query=Red%20steel%20fire%20extinguisher%20cabinet%20with%20glass%20viewing%20window%20and%20lock%2C%20professional%20fire%20safety%20equipment%20storage%20with%20QCDD%20approval%20marking%20mounted%20on%20white%20wall&width=300&height=200&seq=extinguisher-cabinets-related&orientation=landscape',
      category: 'Accessories',
      compliance: 'Weather Resistant'
    },
    {
      id: 18,
      title: 'Fire Blankets',
      image: 'https://readdy.ai/api/search-image?query=Professional%20fire%20blanket%20in%20red%20protective%20case%20with%20safety%20accessories%2C%20fire-resistant%20suppression%20equipment%20for%20kitchen%20and%20industrial%20use%20with%20QCDD%20certification%20marking&width=300&height=200&seq=fire-blankets-related&orientation=landscape',
      category: 'Accessories',
      compliance: 'Fire Resistant'
    }
  ];

  return (
    <div className="min-h-screen">
      <ProductDetailHero product={product} />
      <ProductFeatures features={features} />
      <ProductSpecifications specifications={specifications} />
      <ComplianceSection />
      <RelatedProducts products={relatedProducts} />
      <ProductCTA />
      
      {/* Floating WhatsApp Button */}
      <div className="fixed bottom-8 right-8 z-50">
        <a 
          href="https://wa.me/97455544093"
          target="_blank"
          rel="noopener noreferrer"
          className="w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 flex items-center justify-center group"
        >
          <i className="ri-whatsapp-line text-2xl group-hover:scale-110 transition-transform"></i>
        </a>
      </div>
    </div>
  );
}
